import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";
export const ripeningApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        createRoomCase: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ripening-data/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['roomCase', 'ripeningRoomById', 'ripeningSummary', 'ripeningRooms',],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Record")

            },

        }),
        getRooms: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/ripening-data/rooms?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['ripeningRooms'],
            async onQueryStarted(_, { queryFulfilled, }) {


                await handleQueryError(queryFulfilled)
            },
        }),
        getRipeningRoomById: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/ripening-data/ripening-room?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['ripeningRoomById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getRoomCaseById: build.query({
            query: (id) => {
                return {
                    url: `/ripening-data/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['roomCaseById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateRipeningToSorting: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/ripening-data/ready-for-sorting/${id}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['roomCaseById', 'roomCases', 'ripeningRoomById', 'ripeningSummary', 'ripeningRooms',],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Record")
            },
        }),
        updateRipeningToMoved: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/ripening-data/moved/${id}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['roomCaseById', 'roomCases', 'ripeningRoomById', 'ripeningSummary', 'ripeningRooms', 'sortingSummary', 'getPallets'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Record")
            },
        }),






    }),
});

export const {
    useGetRoomsQuery,
    useGetRipeningRoomByIdQuery,
    useCreateRoomCaseMutation,
    useGetRoomCaseByIdQuery,
    useUpdateRipeningToSortingMutation,
    useUpdateRipeningToMovedMutation,

} = ripeningApi;